import CoreMatchStartPlayingView from
	'../../../../../../core/views/Onboarding/steps/MatchStartPlaying';
// import { redirectTo } from '../../../../utils';
import template from './index.jst';
import Radio from "backbone.radio";

const channel = Radio.channel('coach');
class MatchStartPlayingView extends CoreMatchStartPlayingView {
	get template() {
		return template;
	}

	get team_name_key() {
		return 'team_name';
	}

	get sponsor_key() {
		return 'fantasy_sponsor';
	}

	completionRedirect() {
		channel.trigger('show:popup');
		// redirectTo('fantasy-coach');
	}
}

export default MatchStartPlayingView;